import React from 'react';
import styled from 'styled-components';
import Icon from 'js/components/common/Icon';
import { upTo } from 'js/services/MediaQuery';

const Container = styled.div`
  align-self: start;
  justify-self: center;
  user-select: none;
  height: 100%;
`;

const Image = styled.img`
  max-width: 100%;
  max-height: 100%;
`;

const IconLogo = styled(Icon)`
  font-size: 2.5rem;

  ${upTo('sm')`
    font-size: 2rem;
  `}
`;

export default ({ logo_type, logo }) => (
  <Container>
    {logo_type === 'bank_institution' ? (
      <Image src={`data:image/jpeg;base64,${logo}`} />
    ) : logo_type === 'bank_default' ? (
      <IconLogo name="university" />
    ) : null}
  </Container>
);
